import { useCallback } from "react";

export const useScrollIntoView = (className, lastElement = true) => {
  const scrollIntoViewByElement = useCallback(() => {
    const elements = document.getElementsByClassName(`${className}`);

    if (elements && elements.length) {
      const element = lastElement ? elements[elements.length - 1] : elements[0];
      if (element) {
        element.scrollIntoView({
          behavior: "smooth",
        });
      }
    }
  }, [className, lastElement]);

  return {
    scrollIntoViewByElement,
  };
};
